"use client";

import _toConsumableArray from "/codebuild/output/src934747875/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/codebuild/output/src934747875/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useSafeLayoutEffect } from "./ABQUS43J.js";

// src/dialog/utils/use-nested-dialogs.tsx
import { chain } from "@ariakit/core/utils/misc";
import { sync } from "@ariakit/core/utils/store";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
var NestedDialogsContext = createContext({});
function useNestedDialogs(store) {
  var context = useContext(NestedDialogsContext);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    dialogs = _useState2[0],
    setDialogs = _useState2[1];
  var add = useCallback(function (dialog) {
    var _a;
    setDialogs(function (dialogs2) {
      return [].concat(_toConsumableArray(dialogs2), [dialog]);
    });
    return chain((_a = context.add) == null ? void 0 : _a.call(context, dialog), function () {
      setDialogs(function (dialogs2) {
        return dialogs2.filter(function (d) {
          return d !== dialog;
        });
      });
    });
  }, [context]);
  useSafeLayoutEffect(function () {
    return sync(store, ["open", "contentElement"], function (state) {
      var _a;
      if (!state.open) return;
      if (!state.contentElement) return;
      return (_a = context.add) == null ? void 0 : _a.call(context, store);
    });
  }, [store, context]);
  var providerValue = useMemo(function () {
    return {
      store: store,
      add: add
    };
  }, [store, add]);
  var wrapElement = useCallback(function (element) {
    return /* @__PURE__ */jsx(NestedDialogsContext.Provider, {
      value: providerValue,
      children: element
    });
  }, [providerValue]);
  return {
    wrapElement: wrapElement,
    nestedDialogs: dialogs
  };
}
export { useNestedDialogs };